import { container } from '@shared/common/dependency-injection/domain/container';
import { UsageDataModuleRoutes } from '@client/feature/usage-data/application/routes/usage-data.module-routes';

export const usageDataRoutes = new UsageDataModuleRoutes(container).getRoutes();
